import type { Uuid } from '@nodes/app-v2.1.0'
import { setItems } from '@shared/item-v0.1.0'
import type { NoodlNode } from '@shared/node-v1.0.0'
import { sendSignal } from '@shared/port-send-v1.0.0'
import type { Props } from '../node/definition'
import type { LiveQueryResult, SItem } from '../node/store'
import { fetch } from './fetch'

export const handleSubscribe = async (p: Props, noodlNode: NoodlNode) => {
	// Готовим live-запросы
	const liveQueryResults: LiveQueryResult[] = []

	for (const liveQuery of p.liveQueries || []) {
		const liveQueryResult = liveQuery(p.store.response)

		if (typeof liveQueryResult.query !== 'string') {
			R.libs.mantine.MantineError('Системная ошибка!', 'useData live-query function result error: query key must be string')
			log.error('useData live-query function result error: query key must be string', liveQueryResult)
			return
		}

		if (!liveQueryResult.query.startsWith('LIVE ')) {
			R.libs.mantine.MantineError(
				'Системная ошибка!',
				'useData live-query function result error: query must start with LIVE statement'
			)
			log.error('useData live-query function result error: query must start with LIVE statement', liveQueryResult)
			return
		}

		if (liveQueryResult.refetch !== undefined && typeof liveQueryResult.refetch !== 'boolean') {
			R.libs.mantine.MantineError('Системная ошибка!', 'useData live-query function result error: refetch key must be boolean')
			log.error('useData live-query function result error: refetch key must be boolean', liveQueryResult)
			return
		}

		if (liveQueryResult.signal !== undefined && typeof liveQueryResult.signal !== 'boolean') {
			R.libs.mantine.MantineError('Системная ошибка!', 'useData live-query function result error: signal key must be boolean')
			log.error('useData live-query function result error: signal key must be boolean', liveQueryResult)
			return
		}

		liveQueryResults.push(liveQueryResult)
	}

	// Подписка
	for (const liveQueryResult of liveQueryResults) {
		if (!p.store.subscribes.has(liveQueryResult)) subscribe(p, noodlNode, liveQueryResult)
	}

	// Отписка
	p.store.subscribes.forEach((liveUuid, liveQueryResult) => {
		if (!liveQueryResults.includes(liveQueryResult)) unSubscribe(p, liveQueryResult, liveUuid)
	})
}

const subscribe = async (p: Props, noodlNode: NoodlNode, liveQueryResult: LiveQueryResult) => {
	try {
		const { db, jsonify } = R.surreal

		const liveUuid = await db.query<SItem[]>(liveQueryResult.query)

		await db.subscribeLive<SItem>(liveUuid as any, (action, sItem) => {
			log.info('live action', action, sItem)

			if (action === 'CLOSE') return

			if (['CREATE', 'UPDATE'].includes(action)) setItems([sItem])

			if (action === 'DELETE') {
				const id = sItem.id.id
				delete R.items[id]
			}

			if (liveQueryResult.refetch) fetch(p, noodlNode, true)
			if (liveQueryResult.signal) sendSignal(noodlNode, 'fetched')
		})

		p.store.subscribes.set(liveQueryResult, jsonify(liveUuid[0]))

		log.info('Subscribed to:', liveQueryResult)
	} catch (e: any) {
		log.error('Subscribing:', { error: e.message, liveQueryResult })
	}
}

const unSubscribe = async (p: Props, liveQueryResult: LiveQueryResult, liveUuid: Uuid) => {
	try {
		await R.surreal.db.kill(liveUuid)
		p.store.subscribes.delete(liveQueryResult)
		log.info('Unsubscribed from:', liveQueryResult)
	} catch (e: any) {
		console.error('Error unsubscribing:', { error: e.message, liveQueryResult })
	}
}

export const unSubscribeAll = async (p: Props) =>
	await Promise.all([...p.store.subscribes].map(([query, liveUuid]) => unSubscribe(p, query, liveUuid)))
